var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as Logo } from '../assets/archidekt_logo.svg';
// import {ReactComponent as LogoText} from '../assets/logo_text.svg'
import styles from '../styles/ArchidektLogo.module.scss';
var ArchidektLogo = function () {
    return (_jsx("div", __assign({ className: styles.logoContainer }, { children: _jsx("a", __assign({ href: "https://archidekt.com", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(Logo, { height: 15 }, void 0) }), void 0) }), void 0));
};
export default ArchidektLogo;
